<toast></toast>
<loader></loader>
<confirm></confirm>

<router-outlet></router-outlet>
